var _defs, _g, _path, _path2, _rect, _g2, _path3, _polygon, _polygon2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _polygon3, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _polygon4, _polygon5, _path44, _path45, _path46, _rect2, _polygon6, _rect3, _rect4, _rect5, _polygon7, _rect6, _rect7, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 2000 2000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -2481.27,
    x2: 308.17,
    y1: 976.01,
    y2: 976.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4dbea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 128.3,
    x2: 1683.7,
    y1: 1009.02,
    y2: 1009.02,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 1244.28,
    x2: 1557.31,
    y1: 494.39,
    y2: 494.39,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -111.82,
    x2: 2677.62,
    y1: 997.85,
    y2: 997.85,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 998.97,
    x2: 1261.34,
    y1: 1479.07,
    y2: 1479.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6669b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33308e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 1182.4,
    x2: 1457.05,
    y1: 1545.81,
    y2: 1545.81,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 1457.55,
    x2: 1541.55,
    y1: 1346.69,
    y2: 1346.69,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 1337.05,
    x2: 1644.77,
    y1: 1177.09,
    y2: 1177.09,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 1114.21,
    x2: 1350.04,
    y1: 1338.03,
    y2: 1338.03,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -489.02,
    x2: -223.63,
    y1: 1175.31,
    y2: 1175.31,
    gradientTransform: "rotate(20.27 1267.488 6304.17)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd10a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47521"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 944.77,
    x2: 1441.72,
    y1: 1350.72,
    y2: 1350.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbad18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47820"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 930.26,
    x2: 1500.1,
    y1: 1222.56,
    y2: 1222.56,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 411.87,
    x2: 1325.87,
    y1: 1247.13,
    y2: 1247.13,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 1420.29,
    x2: 1443.94,
    y1: 944.49,
    y2: 944.49,
    gradientTransform: "rotate(-15.56 2053.347 2766.309)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9fcbed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6e8f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 1391.81,
    x2: 1415.46,
    y1: 944.49,
    y2: 944.49,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 1363.32,
    x2: 1386.97,
    y1: 944.48,
    y2: 944.48,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 1334.84,
    x2: 1358.49,
    y1: 944.48,
    y2: 944.48,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 1311.13,
    x2: 1324.95,
    y1: 944.48,
    y2: 944.48,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 1294.34,
    x2: 1308.16,
    y1: 944.48,
    y2: 944.48,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 1278.53,
    x2: 1292.35,
    y1: 944.48,
    y2: 944.48,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 203.21,
    x2: 359.19,
    y1: 1400,
    y2: 1400,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 405.01,
    x2: 608.23,
    y1: 1446.03,
    y2: 1446.03,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-912.88,322.41c215.08,61.94,576.25,253.28,560,692.78S-752.58,1228-1040.6,1625.11c-214.74,296.06-1113.62-108.75-582.87-978.51C-1412.14,300.27-1099.54,268.66-912.88,322.41Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M820.8,306.55C1031.48,348.06,1139,586.66,1478.3,799s264.57,1041.37-271.24,906.16c-511.17-129-534.84-118.81-869.61-106.9C-81.59,1613.15,154.11,175.22,820.8,306.55Z",
    "data-name": "SVGID"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1355.48,
    height: 1545.47,
    x: -1104.27,
    y: 140.87,
    fill: "#fff",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "-201.88 1639.62 -254.48 1639.62 229.02 300.77 229.02 408.63 -201.88 1639.62",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M308.17,479.26V461.58h-48.7V182.82H-2481.27v35.37h29.53v12.48h874.13V461.58h-903.66v17.68h903.66V933.12h-903.66V950.8h903.66v453.85h-903.66v17.68h903.66v295.73h-873.85v10.23h-29.81v40.91H259.46v-3.28h0V1422.33h48.7v-17.68h-48.7V950.8h48.7V933.12h-48.7V479.26ZM-1096,950.8h422.17v453.85H-1096Zm0-17.68V479.26h422.17V933.12Zm0-471.54V230.66h422.17V461.58Zm0,960.75h422.17v295.73h-422v10.23h-.15Zm451.83,295.73V1422.33H-222v295.73Zm0-313.41V950.8H-222v453.85Zm0-471.53V479.26H-222V933.12Zm0-471.54V230.66H-222V461.58Zm451.82-230.92H229.82V461.58H-192.36Zm-1355.6,0h422.18V461.58H-1548Zm0,248.6h422.18V933.12H-1548Zm0,471.54h422.18v453.85H-1548Zm0,471.53h422.18v306h-.16v-10.23h-422Zm1777.78,306h-.16v-10.23h-422V1422.33H229.82Zm0-323.64H-192.36V950.8H229.82Zm0-471.53H-192.36V479.26H229.82Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M820.8,306.55C1031.48,348.06,1139,586.66,1478.3,799s264.57,1041.37-271.24,906.16c-511.17-129-534.84-118.81-869.61-106.9C-81.59,1613.15,154.11,175.22,820.8,306.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M1392.17,656.33C1293.3,577.65,1211,440.34,1257.78,308s143.5,114,221.3,196C1591.64,622.73,1599.11,821,1392.17,656.33Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1461.97,
    height: 10.18,
    x: 169.43,
    y: 1720.1,
    fill: "#cbd3eb"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#cbd3eb",
    points: "467.5 736.67 467.5 681.95 558.26 681.95 558.26 420.42 583.28 420.42 583.28 681.95 681.05 681.95 681.05 736.67 733.41 736.67 733.41 1833.23 355.76 1833.23 355.76 736.67 467.5 736.67"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 52.37,
    height: 986.4,
    x: 355.76,
    y: 736.67,
    fill: "#d6dcf0",
    transform: "rotate(180 381.945 1229.875)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 377.64,
    height: 835.35,
    x: 544.58,
    y: 997.88,
    fill: "#cbd3eb",
    transform: "rotate(180 733.405 1415.555)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 52.37,
    height: 835.35,
    x: 544.58,
    y: 997.88,
    fill: "#d6dcf0",
    transform: "rotate(180 570.77 1415.555)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 815.35,
    y: 1033.47,
    fill: "#d6dcf0",
    transform: "rotate(180 842.44 1044.715)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 724.11,
    y: 1033.47,
    fill: "#d6dcf0",
    transform: "rotate(180 751.2 1044.715)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 815.35,
    y: 1115.36,
    fill: "#d6dcf0",
    transform: "rotate(180 842.44 1126.605)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 724.11,
    y: 1115.36,
    fill: "#d6dcf0",
    transform: "rotate(180 751.2 1126.605)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 632.87,
    y: 1115.36,
    fill: "#d6dcf0",
    transform: "rotate(180 659.965 1126.605)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 815.35,
    y: 1197.25,
    fill: "#d6dcf0",
    transform: "rotate(180 842.44 1208.495)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 632.87,
    y: 1197.25,
    fill: "#d6dcf0",
    transform: "rotate(180 659.965 1208.495)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 724.11,
    y: 1238.2,
    fill: "#d6dcf0",
    transform: "rotate(180 751.2 1249.445)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 815.35,
    y: 1279.14,
    fill: "#d6dcf0",
    transform: "rotate(180 842.44 1290.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 724.11,
    y: 1320.09,
    fill: "#d6dcf0",
    transform: "rotate(180 751.2 1331.335)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 815.35,
    y: 1361.03,
    fill: "#d6dcf0",
    transform: "rotate(180 842.44 1372.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 632.87,
    y: 1361.03,
    fill: "#d6dcf0",
    transform: "rotate(180 659.965 1372.28)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 815.35,
    y: 1436.71,
    fill: "#d6dcf0",
    transform: "rotate(180 842.44 1447.955)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 724.11,
    y: 1436.71,
    fill: "#d6dcf0",
    transform: "rotate(180 751.2 1447.955)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 815.35,
    y: 1518.6,
    fill: "#d6dcf0",
    transform: "rotate(180 842.44 1529.845)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 724.11,
    y: 1518.6,
    fill: "#d6dcf0",
    transform: "rotate(180 751.2 1529.845)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 632.87,
    y: 1518.6,
    fill: "#d6dcf0",
    transform: "rotate(180 659.965 1529.845)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 815.35,
    y: 1600.49,
    fill: "#d6dcf0",
    transform: "rotate(180 842.44 1611.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 632.87,
    y: 1600.49,
    fill: "#d6dcf0",
    transform: "rotate(180 659.965 1611.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 724.11,
    y: 1641.44,
    fill: "#d6dcf0",
    transform: "rotate(180 751.2 1652.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 632.87,
    y: 1641.44,
    fill: "#d6dcf0",
    transform: "rotate(180 659.965 1652.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 815.35,
    y: 1682.38,
    fill: "#d6dcf0",
    transform: "rotate(180 842.44 1693.63)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 724.11,
    y: 1723.33,
    fill: "#d6dcf0",
    transform: "rotate(180 751.2 1734.575)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 815.35,
    y: 1764.27,
    fill: "#d6dcf0",
    transform: "rotate(180 842.44 1775.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 54.19,
    height: 22.49,
    x: 632.87,
    y: 1764.27,
    fill: "#d6dcf0",
    transform: "rotate(180 659.965 1775.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 377.64,
    height: 835.35,
    x: 1448.17,
    y: 997.88,
    fill: "#cbd3eb",
    transform: "rotate(180 1636.99 1415.555)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 52.37,
    height: 835.35,
    x: 1448.17,
    y: 997.88,
    fill: "#d6dcf0",
    transform: "rotate(180 1474.355 1415.555)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 506.69,
    height: 1232.68,
    x: 911.72,
    y: 600.55,
    fill: "#cbd3eb",
    transform: "rotate(180 1165.065 1216.895)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 52.36,
    height: 1232.68,
    x: 911.72,
    y: 600.55,
    fill: "#d6dcf0",
    transform: "rotate(180 937.895 1216.895)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1285.9,
    y: 659.59,
    fill: "#d6dcf0",
    transform: "rotate(180 1325.465 676.015)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1152.67,
    y: 659.59,
    fill: "#d6dcf0",
    transform: "rotate(180 1192.235 676.015)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.85,
    x: 1285.9,
    y: 779.17,
    fill: "#d6dcf0",
    transform: "rotate(180 1325.465 795.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.85,
    x: 1152.67,
    y: 779.17,
    fill: "#d6dcf0",
    transform: "rotate(180 1192.235 795.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.85,
    x: 1019.43,
    y: 779.17,
    fill: "#d6dcf0",
    transform: "rotate(180 1059 795.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1285.9,
    y: 898.76,
    fill: "#d6dcf0",
    transform: "rotate(180 1325.465 915.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1019.43,
    y: 898.76,
    fill: "#d6dcf0",
    transform: "rotate(180 1059 915.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1152.67,
    y: 958.55,
    fill: "#d6dcf0",
    transform: "rotate(180 1192.235 974.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.85,
    x: 1285.9,
    y: 1018.34,
    fill: "#d6dcf0",
    transform: "rotate(180 1325.465 1034.765)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1152.67,
    y: 1078.14,
    fill: "#d6dcf0",
    transform: "rotate(180 1192.235 1094.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1285.9,
    y: 1137.93,
    fill: "#d6dcf0",
    transform: "rotate(180 1325.465 1154.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1019.43,
    y: 1137.93,
    fill: "#d6dcf0",
    transform: "rotate(180 1059 1154.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1285.9,
    y: 1248.44,
    fill: "#d6dcf0",
    transform: "rotate(180 1325.465 1264.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1152.67,
    y: 1248.44,
    fill: "#d6dcf0",
    transform: "rotate(180 1192.235 1264.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1285.9,
    y: 1368.02,
    fill: "#d6dcf0",
    transform: "rotate(180 1325.465 1384.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1152.67,
    y: 1368.02,
    fill: "#d6dcf0",
    transform: "rotate(180 1192.235 1384.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1019.43,
    y: 1368.02,
    fill: "#d6dcf0",
    transform: "rotate(180 1059 1384.44)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1285.9,
    y: 1487.61,
    fill: "#d6dcf0",
    transform: "rotate(180 1325.465 1504.03)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1019.43,
    y: 1487.61,
    fill: "#d6dcf0",
    transform: "rotate(180 1059 1504.03)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1152.67,
    y: 1547.4,
    fill: "#d6dcf0",
    transform: "rotate(180 1192.235 1563.82)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1019.43,
    y: 1547.4,
    fill: "#d6dcf0",
    transform: "rotate(180 1059 1563.82)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1285.9,
    y: 1607.19,
    fill: "#d6dcf0",
    transform: "rotate(180 1325.465 1623.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1152.67,
    y: 1666.98,
    fill: "#d6dcf0",
    transform: "rotate(180 1192.235 1683.405)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1285.9,
    y: 1726.78,
    fill: "#d6dcf0",
    transform: "rotate(180 1325.465 1743.195)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 79.13,
    height: 32.84,
    x: 1019.43,
    y: 1726.78,
    fill: "#d6dcf0",
    transform: "rotate(180 1059 1743.195)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 496.61,
    height: 1140.8,
    x: 1708.35,
    y: 692.43,
    fill: "#cbd3eb",
    transform: "rotate(180 1956.655 1262.835)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51.32,
    height: 1140.8,
    x: 1708.35,
    y: 692.43,
    fill: "#d6dcf0",
    transform: "rotate(180 1734.01 1262.835)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77.56,
    height: 30.4,
    x: 1944.51,
    y: 747.07,
    fill: "#d6dcf0",
    transform: "rotate(180 1983.285 762.27)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77.56,
    height: 30.4,
    x: 1944.51,
    y: 857.74,
    fill: "#d6dcf0",
    transform: "rotate(180 1983.285 872.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77.56,
    height: 30.4,
    x: 1813.92,
    y: 857.74,
    fill: "#d6dcf0",
    transform: "rotate(180 1852.7 872.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77.56,
    height: 30.4,
    x: 1813.92,
    y: 968.41,
    fill: "#d6dcf0",
    transform: "rotate(180 1852.7 983.61)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77.56,
    height: 30.4,
    x: 1944.51,
    y: 1023.75,
    fill: "#d6dcf0",
    transform: "rotate(180 1983.285 1038.945)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77.56,
    height: 30.4,
    x: 1944.51,
    y: 1134.42,
    fill: "#d6dcf0",
    transform: "rotate(180 1983.285 1149.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77.56,
    height: 30.4,
    x: 1813.92,
    y: 1189.76,
    fill: "#d6dcf0",
    transform: "rotate(180 1852.7 1204.955)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77.56,
    height: 30.39,
    x: 1944.51,
    y: 1292.03,
    fill: "#d6dcf0",
    transform: "rotate(180 1983.285 1307.225)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77.56,
    height: 30.4,
    x: 1944.51,
    y: 1402.7,
    fill: "#d6dcf0",
    transform: "rotate(180 1983.285 1417.895)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77.56,
    height: 30.4,
    x: 1813.92,
    y: 1402.7,
    fill: "#d6dcf0",
    transform: "rotate(180 1852.7 1417.895)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77.56,
    height: 30.39,
    x: 1813.92,
    y: 1513.37,
    fill: "#d6dcf0",
    transform: "rotate(180 1852.7 1528.565)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77.56,
    height: 30.4,
    x: 1944.51,
    y: 1568.7,
    fill: "#d6dcf0",
    transform: "rotate(180 1983.285 1583.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77.56,
    height: 30.4,
    x: 1813.92,
    y: 1568.7,
    fill: "#d6dcf0",
    transform: "rotate(180 1852.7 1583.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77.56,
    height: 30.4,
    x: 1944.51,
    y: 1679.37,
    fill: "#d6dcf0",
    transform: "rotate(180 1983.285 1694.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 77.56,
    height: 30.4,
    x: 1813.92,
    y: 1734.71,
    fill: "#d6dcf0",
    transform: "rotate(180 1852.7 1749.905)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 319.84,
    height: 778.11,
    x: 103.42,
    y: 1055.13,
    fill: "#cbd3eb",
    transform: "rotate(180 263.34 1444.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 33.05,
    height: 778.11,
    x: 103.42,
    y: 1055.13,
    fill: "#d6dcf0",
    transform: "rotate(180 119.95 1444.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.95,
    height: 20.73,
    x: 339.62,
    y: 1092.4,
    fill: "#d6dcf0",
    transform: "rotate(180 364.595 1102.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.96,
    height: 20.73,
    x: 255.52,
    y: 1092.4,
    fill: "#d6dcf0",
    transform: "rotate(180 280.495 1102.76)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.95,
    height: 20.73,
    x: 339.62,
    y: 1167.88,
    fill: "#d6dcf0",
    transform: "rotate(180 364.595 1178.245)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.96,
    height: 20.73,
    x: 255.52,
    y: 1167.88,
    fill: "#d6dcf0",
    transform: "rotate(180 280.495 1178.245)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.94,
    height: 20.73,
    x: 171.42,
    y: 1167.88,
    fill: "#d6dcf0",
    transform: "rotate(180 196.395 1178.245)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.95,
    height: 20.73,
    x: 339.62,
    y: 1243.36,
    fill: "#d6dcf0",
    transform: "rotate(180 364.595 1253.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.94,
    height: 20.73,
    x: 171.42,
    y: 1243.36,
    fill: "#d6dcf0",
    transform: "rotate(180 196.395 1253.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.96,
    height: 20.73,
    x: 255.52,
    y: 1281.11,
    fill: "#d6dcf0",
    transform: "rotate(180 280.495 1291.475)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.95,
    height: 20.73,
    x: 339.62,
    y: 1318.85,
    fill: "#d6dcf0",
    transform: "rotate(180 364.595 1329.215)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.96,
    height: 20.73,
    x: 255.52,
    y: 1356.59,
    fill: "#d6dcf0",
    transform: "rotate(180 280.495 1366.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.95,
    height: 20.73,
    x: 339.62,
    y: 1394.34,
    fill: "#d6dcf0",
    transform: "rotate(180 364.595 1404.705)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.94,
    height: 20.73,
    x: 171.42,
    y: 1394.34,
    fill: "#d6dcf0",
    transform: "rotate(180 196.395 1404.705)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.95,
    height: 20.73,
    x: 339.62,
    y: 1464.09,
    fill: "#d6dcf0",
    transform: "rotate(180 364.595 1474.46)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.96,
    height: 20.73,
    x: 255.52,
    y: 1464.09,
    fill: "#d6dcf0",
    transform: "rotate(180 280.495 1474.46)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.95,
    height: 20.73,
    x: 339.62,
    y: 1539.58,
    fill: "#d6dcf0",
    transform: "rotate(180 364.595 1549.945)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.96,
    height: 20.73,
    x: 255.52,
    y: 1539.58,
    fill: "#d6dcf0",
    transform: "rotate(180 280.495 1549.945)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.94,
    height: 20.73,
    x: 171.42,
    y: 1539.58,
    fill: "#d6dcf0",
    transform: "rotate(180 196.395 1549.945)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.95,
    height: 20.73,
    x: 339.62,
    y: 1615.06,
    fill: "#d6dcf0",
    transform: "rotate(180 364.595 1625.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.94,
    height: 20.73,
    x: 171.42,
    y: 1615.06,
    fill: "#d6dcf0",
    transform: "rotate(180 196.395 1625.43)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.96,
    height: 20.73,
    x: 255.52,
    y: 1652.81,
    fill: "#d6dcf0",
    transform: "rotate(180 280.495 1663.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.94,
    height: 20.73,
    x: 171.42,
    y: 1652.81,
    fill: "#d6dcf0",
    transform: "rotate(180 196.395 1663.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.95,
    height: 20.74,
    x: 339.62,
    y: 1690.55,
    fill: "#d6dcf0",
    transform: "rotate(180 364.595 1700.915)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.96,
    height: 20.73,
    x: 255.52,
    y: 1728.29,
    fill: "#d6dcf0",
    transform: "rotate(180 280.495 1738.655)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.95,
    height: 20.73,
    x: 339.62,
    y: 1766.03,
    fill: "#d6dcf0",
    transform: "rotate(180 364.595 1776.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.94,
    height: 20.73,
    x: 171.42,
    y: 1766.03,
    fill: "#d6dcf0",
    transform: "rotate(180 196.395 1776.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1355.47,
    height: 1545.48,
    x: -111.14,
    y: 222.92,
    fill: "#fff",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "369.67 1739.9 264.47 1739.9 828.41 240.02 933.61 240.02 369.67 1739.9",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "183.91 1739.9 131.31 1739.9 695.25 240.02 747.85 240.02 183.91 1739.9",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "811.98 1739.9 759.37 1739.9 1242.87 401.05 1242.87 508.92 811.98 1739.9",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1355.48,
    height: 1545.48,
    x: 1265.62,
    y: 191.75,
    fill: "#fff",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "1489.79 1739.9 1384.59 1739.9 1948.53 240.02 2053.74 240.02 1489.79 1739.9",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "1304.03 1739.9 1251.43 1739.9 1815.37 240.02 1867.97 240.02 1304.03 1739.9",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M2677.62,501.1V483.42h-48.7V204.66H-111.82V240h29.53V252.5H791.84V483.42H-111.82V501.1H791.84V955H-111.82v17.69H791.84v453.85H-111.82v17.68H791.84V1739.9H-82v10.23h-29.81V1791H2628.92v-3.29h0V1444.17h48.7v-17.68h-48.7V972.64h48.7V955h-48.7V501.1ZM1273.44,972.64h422.18v453.85H1273.44Zm0-17.69V501.1h422.18V955Zm0-471.53V252.5h422.18V483.42Zm0,960.75h422.18V1739.9h-422v10.23h-.15Zm451.83,295.73V1444.17h422.17V1739.9Zm0-313.41V972.64h422.17v453.85Zm0-471.54V501.1h422.17V955Zm0-471.53V252.5h422.17V483.42ZM821.49,252.5h422.18V483.42H821.49Zm0,248.6h422.18V955H821.49Zm0,471.54h422.18v453.85H821.49Zm0,471.53h422.18v306h-.16V1739.9h-422Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#413c97",
    d: "M447.63 875V797H288.88V731.9L457.15 485.55h62.46V731.63h48.14V797H519.61V875zm0-143.4V599.07L358.47 731.63zM1050.36 875V797H891.61V731.9l168.28-246.35h62.44V731.63h48.16V797h-48.16V875zm0-143.4V599.07L961.2 731.63z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#413c97",
    points: "679.31 777.31 719.14 777.75 679.31 777.9 679.31 777.31"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#cbd3eb",
    points: "719.14 777.75 791.64 777.46 791.64 778.5 719.14 777.75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6669b0",
    d: "M878.56,564.89v1.46a141.8,141.8,0,0,1-37.47,94.88c-28.4,31-49,71-49.46,113v4.23l-115.25-1.12.09-3.8c.43-42.21-19.51-82.79-47.4-114.56a142.41,142.41,0,0,1-32.46-123.27l24.78-16,30.73,66.38,23.75-58.27,22,25.12,64.32-38.58,30.21,54,32.89-22.79L875,567.22Z",
    opacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#413c97",
    d: "M698.89 669.38c-.07-.31-7.12-31.42-12.08-62.44-2.91-18.16-4.33-31.29-4.78-40.8a24.58 24.58 0 01-8.06-3.81c-22-15.42-1.5-46.93-.62-48.27.72-1.08 2.73-1.29 4.46-.4s2.58 2.44 1.88 3.52c-5.45 8.22-16.38 31.8-1.77 42a14.48 14.48 0 004 2c-.27-19.43 4.33-20.13 7-20.52 4.31-.65 8.31.64 10.71 3.44 4.91 5.72 1.4 16.88-6.59 20.92a14.67 14.67 0 01-4.2 1.37c1.19 24 8.07 65 16.82 103.5.31 1.37-.95 2.35-2.81 2.19a5.59 5.59 0 01-1.37-.32A4 4 0 01698.89 669.38zM692 545.66c-2.4.6-3.42 6-3.36 14.81 5.73-3.33 7.83-11.8 5.44-14.59a.74.74 0 00-.3-.21A4 4 0 00692 545.66zM768.68 672.53a5.57 5.57 0 01-1.38.29c-1.88.13-3.11-.88-2.77-2.25 9.53-38.26 17.25-79.16 18.92-103.13a14.27 14.27 0 01-4.16-1.44c-7.91-4.22-11.2-15.44-6.17-21.07 2.45-2.74 6.48-3.95 10.78-3.22 2.66.45 7.25 1.24 6.59 20.66a14.31 14.31 0 004-2c14.81-9.94 4.37-33.75-.9-42.08-.69-1.09.17-2.65 1.94-3.47s3.77-.6 4.46.48c.85 1.36 20.68 33.29-1.61 48.26a24.56 24.56 0 01-8.14 3.64c-.64 9.5-2.33 22.6-5.6 40.7-5.58 30.91-13.28 61.87-13.35 62.18A4 4 0 01768.68 672.53zm10.23-126a.74.74 0 00-.3.2c-2.46 2.74-.53 11.25 5.14 14.7.23-8.78-.69-14.22-3.06-14.88A3.72 3.72 0 00778.91 546.54z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#413c97",
    d: "M699,665.78l3.47-2.82a51.53,51.53,0,0,1,65.33.65l3.42,2.87-1.13,115.15-72.23-.7Zm65.45,3.82-1-.83a44.74,44.74,0,0,0-56.75-.56l-1,.8-1,105.24,58.75.58Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a276f",
    d: "M674.22,786.13l119.41,1.17a8.79,8.79,0,0,0,8.88-8.71h0a8.79,8.79,0,0,0-8.71-8.88l-119.41-1.18a8.81,8.81,0,0,0-8.88,8.72h0A8.81,8.81,0,0,0,674.22,786.13Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#413c97",
    d: "M680.42,803.83l106.64,1c4.34,0,7.89-3.87,7.94-8.72h0c0-4.87-3.43-8.84-7.77-8.88l-106.63-1c-4.34,0-7.9,3.86-8,8.72h0C672.6,799.81,676.08,803.78,680.42,803.83Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a276f",
    d: "M680.24,821.47l106.64,1c4.34,0,7.9-3.86,7.94-8.73h0c0-4.86-3.43-8.84-7.77-8.87l-106.63-1c-4.34,0-7.9,3.87-7.95,8.72h0C672.43,817.45,675.9,821.43,680.24,821.47Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#413c97",
    d: "M680.07,839.11l106.63,1c4.34,0,7.9-3.87,7.94-8.72h0c.05-4.86-3.42-8.84-7.77-8.88l-106.63-1c-4.34,0-7.9,3.86-8,8.73h0C672.25,835.1,675.72,839.06,680.07,839.11Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a276f",
    d: "M679.89,856.75l106.63,1c4.35.05,7.9-3.85,8-8.71h0c0-4.86-3.43-8.83-7.78-8.87l-106.63-1.05c-4.34,0-7.9,3.86-7.94,8.72h0C672.06,852.74,675.55,856.71,679.89,856.75Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#413c97",
    d: "M761.21,875.22l-56.37-.58a17.6,17.6,0,0,1-17.44-17.77h0l91.6.92h0A17.61,17.61,0,0,1,761.21,875.22Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M1247,1348.25l-98.92-34c-9.78-3.37-21.68,1.69-26.51,11.28L999,1574.23l8.35,2.87,122-247.57c2.83-5.61,10.07-8.69,15.8-6.72l98.92,34c5.73,2,9.55,8.85,8.32,15l-56.1,270.23,8.34,2.87,56.35-271.49C1263,1362.92,1256.76,1351.62,1247,1348.25Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a276f",
    d: "M1258.78,1352.31,1166.6,1321c-9.77-3.36-34.33-3.09-39.23,6.45L1007,1577l12.14,4.18L1141,1333.58c2.87-5.62,19-5.64,24.77-3.66l88,30.29c5.75,2,4,8,2.79,14.19l-57,268.8,17,5.83,56.4-271.53C1274.86,1367,1268.55,1355.67,1258.78,1352.31Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a276f",
    d: "M1454.05,1418.81,1341.12,1380c-9.77-3.36-25.34.73-30.36,10.62l-120.37,249.48,12.15,4.17,121.85-247.5c2.94-5.81,10.29-9.06,16-7.08l108.22,37.22c5.75,2,1.71,4.94.46,11.34l-41.86,276.43,15.42,5.31,45.24-275.32C1470,1433.76,1463.83,1422.18,1454.05,1418.81Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M1442.26,1414.75l-110.58-38c-9.77-3.36-21.79,2-26.79,11.87L1182.4,1637.32l8.35,2.87,121.87-247.5c2.93-5.82,10.26-9.07,16-7.09l110.58,38c5.83,2,9.89,9.22,8.89,15.75L1402.39,1713l8.5,2.93,45.9-275.43C1458.46,1429.63,1452,1418.09,1442.26,1414.75Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a276f",
    d: "M1463.66,1412.16l11.15,3.83c12.55-13.72,46-71,67.92-115.84,2.62-5.38,4.7-9.63,5.87-11.83l2.14-4-7.67-4.21C1518.57,1326.31,1465.94,1410.78,1463.66,1412.16Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M1457.55,1410.06l8.76,3c12.64-12.63,46.66-70.36,69.49-117,2.57-5.23,4.59-9.37,5.75-11.55l-7.66-4.21C1506.36,1343.33,1460.33,1408.11,1457.55,1410.06Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#242967",
    d: "M1360.68,1234.56c-6.49,13-40.46,73.14-51.14,91.41-8.69,14.86-14.52,22.72-18.3,26.88l8.34,2.87c12.85-14.82,46.57-72.44,68.88-117.18,2.33-4.68,7.38-14.37,7.38-14.37l-7.66-4.22S1363.05,1229.82,1360.68,1234.56Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a276f",
    d: "M1283.36,1350.14l8.55,2.94c12.62-13.25,46.41-70.89,68.86-116.86,2.62-5.39,4.7-9.65,5.88-11.85l-7.66-4.21C1318.19,1309.93,1286.58,1347.37,1283.36,1350.14Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#29266e",
    d: "M1640.78,1123.74l-165.45-56.91c-15.65-5.38-34.47,1.57-41.82,15.45L1360,1225.41s50,28.63,117.33,51.77,96.19,21.67,96.19,21.67l82.39-140.08C1663.25,1144.89,1656.44,1129.13,1640.78,1123.74Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M1626.69,1118.9,1461.24,1062c-15.65-5.39-34.47,1.56-41.81,15.44l-82.38,140.08s58.9,31.68,126.2,54.83,96.19,21.66,96.19,21.66l82.38-140.08C1649.16,1140,1642.35,1124.28,1626.69,1118.9Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#29266e",
    d: "M1285.55,1348c-.18.45-.4.85-.56,1.31-3.67,10.69-.61,21.44,6.85,24l173,59.51c7.45,2.56,16.48-4,20.16-14.72.15-.45.23-.9.36-1.36Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M1116.16,1289.73c-.18.44-.41.84-.57,1.29-3.68,10.69.23,21.73,8.71,24.65l203.37,69.94c8.49,2.92,18.35-3.38,22-14.07.15-.45.22-.91.34-1.37Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fed2a7",
    d: "M1400.41,1020.68c-27.8-13.1-103.85-97.44-120.29-113.85-19.81-19.77-5.12-51.21,20.21-47.3,21.59,3.33,131.22,95.83,141.52,109.58C1460.46,993.93,1435.2,1037.06,1400.41,1020.68Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#413c97",
    d: "M1314.12,957.82c28.49,27.53,86.61,65.7,100.7,72.34,34.79,16.38,60-26.75,41.43-51.57-5.8-7.74-51.07-50.62-91.94-80.33C1349.12,897.93,1314.75,928.29,1314.12,957.82Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#413c97",
    d: "M1528.31,935.14s-24,43.21-3.68,50.73,56.51,25.82,63.33,48.45-32.48,187.41-89.35,297.49c0,0-152.67-4.64-196.24-97.67,0,0,57.93-237.69,89.39-261.93,26.25-20.22,67-3.79,67-3.79s15.08-5.81,18.62-29.24C1486,882,1528.31,935.14,1528.31,935.14Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M1525.27,941.17c1.73-3.68,3-6,3-6s-34-42.74-47.28-10.32Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a276f",
    d: "M1588,1034.32a39,39,0,0,0-7.54-13.35l-92.5,144.3-185.55,68.87c43.57,93,196.24,97.67,196.24,97.67C1555.48,1221.73,1594.78,1057,1588,1034.32Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#fed2a7",
    d: "M1540.57,992.65c-26,23.18-59.77,29.27-82,12.64-12.78-9.54-19.44-24.84-20-42.09a99.59,99.59,0,0,1,20.18,5.22s15.07-5.81,18.61-29.25c8.64-57.21,51-4,51-4s-24.06,43.19-3.69,50.72C1529.29,987.59,1534.78,989.87,1540.57,992.65Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fed2a7",
    d: "M1540.57,992.65c-26,23.18-59.77,29.27-82,12.64-12.78-9.54-19.44-24.84-20-42.09a99.59,99.59,0,0,1,20.18,5.22s15.07-5.81,18.61-29.25c8.64-57.21,51-4,51-4s-24.06,43.19-3.69,50.72C1529.29,987.59,1534.78,989.87,1540.57,992.65Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbb8f",
    d: "M1524.63,985.87c-20.37-7.53,3.69-50.72,3.69-50.72s-2.19-2.74-5.65-6.3l-7.86,21.28a56.33,56.33,0,0,1-72.36,33.32h0a47.89,47.89,0,0,0,16.1,21.84c22.25,16.63,56,10.54,82-12.64C1534.78,989.87,1529.29,987.59,1524.63,985.87Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2a276f",
    points: "1476.54 877.14 1477.18 875.39 1460.48 869.23 1459.84 870.97 1476.54 877.14"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fed2a7",
    d: "M1481.71,841.08l-23.57,63.8c-7,18.81,3.5,40,23.32,47.33h0c19.83,7.33,41.54-2,48.49-20.8l.58-1.56s21.08,6.14,28.79-14.73-9.14-17.42-9.14-17.42l10.19-27.56Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbb8f",
    d: "M1550.18,897.7l10.19-27.56-27.93-10.31c-.07.2-.12.41-.19.62l-26.68,72.2c-4.66,12.62-20.25,18.5-32.34,13.54a23.76,23.76,0,0,1-9.28-6.78,39.44,39.44,0,0,0,17.51,12.8c19.83,7.33,41.54-2,48.49-20.8l.58-1.56s21.08,6.14,28.79-14.73S1550.18,897.7,1550.18,897.7Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a276f",
    d: "M1549.43,898.2s-12.92,16.49-8.54-7.71-3-25.78-29-33.49-58.24-30.37-33-56.6c24.83-25.78,70.76,17,70.76,17s44.19,2.66,39.27,36.52S1549.43,898.2,1549.43,898.2Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#fed2a7",
    d: "M1589,1031.11c18.24,24.73,45.37,137.57,52,159.81,8,26.8-13.89,48.17-34.33,32.7-17.4-13.18-81.27-153.12-83.81-170.11C1518.36,1022.83,1566.19,1000.17,1589,1031.11Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a276f",
    d: "M1632.93,1128.41c-13.4-42.53-32.45-85.49-42.89-99.65-24.83-33.64-75.86-5.9-70.88,27.45,1.25,8.34,18.23,51,36.52,91.14C1590.78,1150.76,1628.36,1133.41,1632.93,1128.41Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#fed2a7",
    d: "M953.86,1169.53l1.79-28.81c-32.76,2.1-59.66-4.67-39.11-46.18,9.47-19.13-11.15-35.24-11.15-35.24l-49.12,99.25s-.88,11.86,29.41,9C918.58,1164.55,953.86,1169.53,953.86,1169.53Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a276f",
    d: "M895.1,1133.77c8.88-3.37,16.46,9,21.32.44-8.51-6.57-10.28-18.67.12-39.67,9.47-19.13-11.15-35.24-11.15-35.24l-49.12,99.25s-.83,11.14,26.66,9.27C888.09,1157.42,881.71,1138.87,895.1,1133.77Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#fed2a7",
    d: "M896.22,1508.14c34.9,7.28,58.85-31.88,71.54-50.68l27.34,22.87s-30.93,29-37.78,53.58-12.92,20-12.92,20l-99.79-34.32S861.32,1500.85,896.22,1508.14Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a276f",
    d: "M896.22,1508.14c10.53,2.19,23.13-.55,30.59-5.43,5-3.54,19.52,7.26,19.11,17.29,0,0,5,7,13.06,9-.6,1.67-1.21,3.31-1.66,4.91-6.85,24.62-12.92,20-12.92,20l-99.79-34.32S861.32,1500.85,896.22,1508.14Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#fed2a7",
    d: "M1612 1182.12c38.07-6.45 158.08 9.72 178.82-1.86s59.6-18.75 73.8-6.94c14.5 12.07 4.74 23.07-10.83 32-9.88 5.69-21.45 10.49-47.71 7.41s-137.83 21.13-176.61 22.08C1591 1235.78 1586.22 1186.48 1612 1182.12zM1322.18 896.6c6.29-38.1-10.35-145.29 1.14-166.08s18.53-46.93 6.66-61.08c-12.13-14.44-32-14.55-32 11 0 11.4-10.4 21.48-7.22 47.74s-20.59 112.41-21.39 151.19C1268.6 917.78 1317.92 922.37 1322.18 896.6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a276f",
    d: "M1507.42 909.46a15.71 15.71 0 01-9.81-11.24 24.74 24.74 0 01.73-14.34c2.7-7.29 9.93-9.11 20.49-5.28s14.83 10 12.13 17.33c-2.88 7.8-12.21 17.43-23.17 13.66zm-7.34-24.93a22.8 22.8 0 00-.68 13.22 13.92 13.92 0 008.67 10l.31.11c9.81 3.37 18.21-5.43 20.84-12.54 2.92-7.91-4.39-12.5-11-14.95l-.87-.31C1510.81 877.79 1502.88 877 1500.08 884.53zM1468.48 895.07c-11.13-4.11-12-17.69-9.09-25.58 2.69-7.29 10-9.14 20.49-5.28s14.82 10 12.13 17.33c-2.89 7.8-12.21 17.43-23.18 13.66zm-7.35-24.94c-2.65 7.19-2 19.53 8 23.2s18.51-5.25 21.16-12.43c2.92-7.91-4.39-12.5-11-14.95l-.87-.31C1471.86 863.4 1463.93 862.57 1461.13 870.13z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2a276f",
    points: "1499.58 883.53 1500.22 881.79 1492.04 878.77 1491.4 880.51 1499.58 883.53"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2a276f",
    points: "1545.7 902.69 1546.34 900.95 1529.64 894.78 1528.99 896.52 1545.7 902.69"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M1302.36,1284.76c-64.85-50.33-144.9-94.67-185.84-85-7.22,1.69-13.24,5.08-17.73,10.42a54.59,54.59,0,0,0-6.15,9.13l-.11-.07s-111.36,194.54-147.76,252.16c0,0,26.12,27.32,50,31.63,0,0,118.77-118.7,150.86-188.88,2.27,1.35,4.44,2.57,6.39,3.58l1.16.59c.2.11.4.19.59.3s.52.26.79.37c1,.5,1.93.91,2.8,1.28,3.75,1.58,8.18,3.26,13.14,5,.72.26,1.44.5,2.18.74,13.6,4.58,30.92,9.46,49.52,14.28,1.37.37,2.73.71,4.1,1.06,2.87.74,5.76,1.48,8.66,2.19,1.72.44,3.43.87,5.16,1.28,9.84,2.45,19.82,4.82,29.6,7.12,2.57.59,5.13,1.17,7.64,1.76l1.85.44c.93.19,1.87.4,2.78.62,11.79,2.69,23.11,5.21,33.35,7.45,27.87,6,47.82,10,47.82,10s50.06,15.59,75.41-4C1461.63,1350.45,1352.6,1307.11,1302.36,1284.76Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#d25927",
    d: "M1136.81,1308.56c1.06.72,2.11,1.41,3.15,2.09,1.85,1.19,3.62,2.3,5.34,3.32,2.41,1.43,4.67,2.69,6.71,3.75l1.16.59c.2.11.4.19.59.3s.52.26.79.37c1,.5,1.93.91,2.8,1.28,3.75,1.59,8.18,3.26,13.14,5,.72.26,1.44.5,2.18.74,13.6,4.58,30.92,9.46,49.52,14.28,1.37.37,2.73.71,4.1,1.06,2.87.74,5.76,1.48,8.66,2.19,1.72.44,3.43.87,5.16,1.28,9.83,2.45,19.82,4.82,29.6,7.12,2.57.59,5.13,1.17,7.64,1.76l1.85.44c.93.21,1.87.4,2.78.62,11.79,2.69,23.11,5.21,33.35,7.45,27.87,6,47.82,10,47.82,10s50.06,15.59,75.41-4c23.07-17.79-86-61.13-136.2-83.48-64.85-50.33-144.9-94.67-185.84-85,98.49,12.85,130.46,75.18,113.16,100.63C1202.7,1340.1,1141.2,1307.43,1136.81,1308.56Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M1222.16,1066.3a24.15,24.15,0,0,0-12.38,1.1c-26.79,7.68-239.63,68.33-275.75,67,0,0-7,36.27-1.88,70.42,0,0,216.91-21.81,266-28.9,39.34,43.53,100.27,135.27,152.5,176,57.13,44.53,127.41,32.36,149.43-21.13C1500.1,1330.78,1338.89,1084.15,1222.16,1066.3Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 22.4,
    height: 450.86,
    x: 1488.09,
    y: 1269.09,
    fill: "#29266e"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29266e",
    points: "862.6 1719.95 882.53 1719.95 882.53 1478.02 882.53 1269.09 862.6 1269.09 862.6 1719.95"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 274.14,
    height: 11.61,
    x: 1264.27,
    y: 1257.47,
    fill: "#2a276f"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 820.54,
    height: 11.61,
    x: 443.73,
    y: 1257.47,
    fill: "#29266e"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 25.17,
    height: 450.86,
    x: 1203.7,
    y: 1269.09,
    fill: "#29266e"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#29266e",
    points: "487.91 1719.95 510.34 1719.95 510.34 1478.02 510.34 1269.09 487.91 1269.09 487.91 1719.95"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 274.14,
    height: 20.68,
    x: 1324.34,
    y: 1236.79,
    fill: "#29266e"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 914,
    height: 20.68,
    x: 411.87,
    y: 1236.79,
    fill: "url(#p)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#6669b0",
    d: "M1026.1,1171.36a1.38,1.38,0,0,0,1.71,1l229.53-63.92a2.75,2.75,0,0,0,1.92-3.39l-1.78-6.41-233.53,65Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#413c97",
    d: "M1226.74 1104.24l.75 2.7 8.19-2.28-1-3.59-7.3 2A.93.93 0 001226.74 1104.24zM1217.23 1106.89l.75 2.7 8.2-2.28-1-3.59-7.29 2A.92.92 0 001217.23 1106.89zM1207.73 1109.54l.74 2.7 8.2-2.28-1-3.6-7.31 2A.92.92 0 001207.73 1109.54zM1168.11 1120.57l.76 2.7 8.19-2.28-1-3.6-7.3 2A.93.93 0 001168.11 1120.57zM1158.61 1123.22l.75 2.69 8.19-2.28-1-3.59-7.3 2A.92.92 0 001158.61 1123.22zM1047 1154.29l.76 2.7 8.19-2.28-1-3.59-7.3 2A.93.93 0 001047 1154.29z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#101013",
    d: "M1037.51,1156.93l.75,2.71,8.19-2.28-1-3.6-7.3,2A.91.91,0,0,0,1037.51,1156.93Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#413c97",
    d: "M1177.9,1117.84l.76,2.7,28.17-7.84-1-3.6-27.28,7.6A.92.92,0,0,0,1177.9,1117.84Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#101013",
    d: "M1006.64,1165.53l.76,2.7,28.17-7.85-1-3.59-27.28,7.6A.94.94,0,0,0,1006.64,1165.53Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#413c97",
    d: "M1057.41,1151.39l.75,2.7,97.83-27.24-1-3.59-96.94,27A.93.93,0,0,0,1057.41,1151.39Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M976.16,1173.06l-19.86,5.53a2.1,2.1,0,0,0-1.46,2.59l.44,1.56,22.77-6.34-.75-2.7A.92.92,0,0,0,976.16,1173.06Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M948.73,1180.7l-19.87,5.53a2.1,2.1,0,0,0-1.46,2.59l.44,1.56,22.77-6.34-.75-2.7A.92.92,0,0,0,948.73,1180.7Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M921.28,1188.34l-19.86,5.53a2.09,2.09,0,0,0-1.46,2.59l.43,1.56,22.78-6.34-.74-2.7A.94.94,0,0,0,921.28,1188.34Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M893.84,1196,874,1201.51a2.1,2.1,0,0,0-1.46,2.59l.44,1.56,22.77-6.34-.74-2.7A.94.94,0,0,0,893.84,1196Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M861.54,1205l-10.4,2.9a2.11,2.11,0,0,0-1.46,2.59l.43,1.57,13.32-3.71-.75-2.7A.93.93,0,0,0,861.54,1205Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M845.36,1209.48,835,1212.37a2.11,2.11,0,0,0-1.46,2.6l.43,1.56,13.31-3.71-.75-2.7A.93.93,0,0,0,845.36,1209.48Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M830.13,1213.72l-10.39,2.89a2.11,2.11,0,0,0-1.46,2.6l.43,1.56,13.32-3.71-.76-2.7A.92.92,0,0,0,830.13,1213.72Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#413c97",
    d: "M961.32,995c-4-6.73-10.63-9.57-19-7.23L1048,1165.56s9.3-5.7,4.06-14.83C1047.69,1143.1,983.14,1031.27,961.32,995Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#6669b0",
    d: "M941.3 988.06l-244.47 68.07a5.45 5.45 0 00-3.26 7.95l94.49 165.22 257-71.56-95-166.09A7.71 7.71 0 00941.3 988.06zM791.16 1236.78a1.38 1.38 0 001.7 1l252.26-70.24a2.76 2.76 0 001.92-3.4l-1.78-6.41-257.2 71.61zM435 1298.3c10.05 0 19.21-3.49 27.23-9a232.94 232.94 0 01-4 50c-10.7 17.24-40.38 49-38.38 48.78 8.3-.67 16.1-2.87 23.82-5.55a177 177 0 01-18.15 29.67c-14.39 19.21-34.91 34.57-42.71 58a1.48 1.48 0 01-.9 1 1.7 1.7 0 01-2.81 1.24c-38.74-36.78-45.66-92.66-51.35-143-.27-2.39-.54-4.74-.76-7.14 10.73 10.73 22.14 20.54 35.71 27.87 1.88 1-24.26-40.8-37.05-60.06a113.16 113.16 0 016.66-35.78c9.07-24.29 24.61-47 39.7-67.93.61-.86 1.31-1.69 1.92-2.55a116 116 0 0016.66 30.19c1.25 1.63-2.74-30.57-5.19-45.28 3.79-4.7 7.57-9.4 11.51-13.94 5.17-6.09 11.54-16.41 20.82-15 9 1.27 29.51 38.13 32.1 48.67 1.13 4.5 2.14 9.11 3.05 13.72.44 2 .81 4 1.16 6a556.38 556.38 0 016.91 56.1c-.64 1-1.28 2-2 3C451.39 1277.5 433.16 1298.29 435 1298.3z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#33308e",
    d: "M399.71,1279.74c19.11-2.89,33.71-15,47.75-27.41,2.1-1.86-.5-5.39-2.62-3.52-13.15,11.67-26.84,23.34-44.67,26.38,4.06-28.46,8.8-56.83,14.39-85,.54-2.77-3.78-3.44-4.33-.69q-11.1,56.11-18.12,112.83a187.41,187.41,0,0,1-25.3-50.84c-.86-2.68-4.92-1-4.06,1.63a191.22,191.22,0,0,0,27.14,53.7,2,2,0,0,0,1.58.86c-1,8.27-1.92,16.54-2.81,24.82a118,118,0,0,1-18.77-32.86c-1-2.63-5-1-4.07,1.64a121.53,121.53,0,0,0,21.35,36.42,2.15,2.15,0,0,0,.9.63q-4.21,40.86-6.37,81.93a2.2,2.2,0,0,0-.25.93q-.88,15-1.05,30-.33,9.78-.53,19.58a1.73,1.73,0,0,0,.63,1.47c1.13,61.66,10.27,122.64,23.24,183,1.41-.35,2.84-.66,4.25-1-14.65-68.19-24.4-137.21-23.12-207.1q.39-11.05.93-22.12a2.06,2.06,0,0,0,1.94-.24,72.88,72.88,0,0,0,20-20.49c1.53-2.34-1.89-5.09-3.42-2.73a69.88,69.88,0,0,1-18.32,19q3.64-70.69,13.51-140.83A1,1,0,0,0,399.71,1279.74Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M247.76,1406.44a47.58,47.58,0,0,1-25.76,2.2,166.28,166.28,0,0,0,18,36.26c14.1,9.44,48.56,23.52,46.8,24a96.65,96.65,0,0,1-21.87,3.66,140.91,140.91,0,0,0,24,16.33c17.82,9.7,39.73,14.49,53.17,29.54a1.27,1.27,0,0,0,1.06.48,1.58,1.58,0,0,0,2.75,0c22.24-40.37,11.89-84.64,2.08-124.36-.46-1.88-.92-3.74-1.42-5.61-6,11.59-12.86,22.71-22.25,32.68-1.31,1.38,8.75-38.63,14-57.31a81.78,81.78,0,0,0-16.07-24.69c-14.77-15.27-34.58-27.24-53.48-38-.77-.44-1.61-.84-2.37-1.29a90.81,90.81,0,0,1-5.4,28.17c-.58,1.63-6.55-23.87-8.74-35.73-4.58-2.29-9.17-4.57-13.83-6.69-6.17-2.88-14.59-8.54-22.07-4.46-7.28,3.92-14,38.35-13.15,47.13.35,3.75.83,7.54,1.39,11.3.2,1.63.48,3.28.76,4.89a398.23,398.23,0,0,0,10.43,44.42c.84.54,1.66,1.08,2.56,1.57C227.79,1396.2,249.33,1405.82,247.76,1406.44Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#33308e",
    d: "M378.06,1664.33c-6.51-49.61-16.47-98.43-33.42-145.14a1.33,1.33,0,0,0,.1-1.31q-3-7.29-6.14-14.53-4.5-11.2-9.61-22.22a1.58,1.58,0,0,0-.49-.61q-13.75-30.13-29.22-59.47a2,2,0,0,0,.59-.76,96,96,0,0,0,7.55-34.39c.07-2.31-3.86-2.19-3.92.11a92.71,92.71,0,0,1-6.42,30.86q-4.72-8.89-9.6-17.73a1.84,1.84,0,0,0,1.1-1.17,148.28,148.28,0,0,0,7.47-49.26c-.05-2.3-4-2.19-3.93.11a144.89,144.89,0,0,1-6.73,46.51q-22.5-40.26-48.19-78.81c-1.26-1.9-4.75,0-3.48,1.93q19.42,29.05,36.94,59.17c-16,3.58-31.07-.68-45.64-5.13-2.34-.71-3.52,2.79-1.21,3.5,15.56,4.74,31.48,9,48.57,4.9.06,0,.09-.05.15-.07q28.7,49.42,52.4,101.37a59.91,59.91,0,0,1-21.1-8.27c-2-1.27-4.1,1.92-2.12,3.18a63.08,63.08,0,0,0,23,8.81,2.1,2.1,0,0,0,1.72-.46q3.66,8.13,7.21,16.31c21.39,52.09,33.17,107.15,40.53,163.21C375.45,1664.76,376.75,1664.53,378.06,1664.33Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#87afdd",
    d: "M238.73,1353.42a100.38,100.38,0,0,1-34.06-13.31c.2,1.63.48,3.28.76,4.89a105.09,105.09,0,0,0,32.07,11.91C240,1357.37,241.14,1353.89,238.73,1353.42Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M608.23,1386.24c-.24,15.76-36.69,23.39-48.26,27.68-25.62,9.48-50.63,19-69.57,39.66-22.34,24.3-41.59,52.34-60.86,79.13a4.52,4.52,0,0,1-4.55,2c-.28,0-2.46-4.54-5.3-11.52-6.64-16.37-16.81-46.32-14.29-63.39a103.62,103.62,0,0,1,11.62-34c1.31,5.39,3.49,10.52,7.3,14.42.92.93,2.89-21.53,4.2-31.73,1.69-2.07,3.4-4.07,5.2-6A113.49,113.49,0,0,1,447.19,1390c1-.82,2.05-1.63,3.1-2.39a142.62,142.62,0,0,1,12.27-8.15c1.12-.66,2.26-1.31,3.44-2,3.95-2.19,8.06-4.23,12.26-6.07a82.82,82.82,0,0,0,6.77,22.47c.7,1.5,2.42-17.75,2.67-26.26,4-1.5,8-2.74,12.11-3.91a63.8,63.8,0,0,0,5,14.51c.55,1.11,6-11.92,7.93-17.65a158.45,158.45,0,0,1,39-3.06c1.12,0,2.23.1,3.31.21,3.5.24,7,.63,10.37,1.15,12.56,2,42.14,9.91,42.72,26.89A2.57,2.57,0,0,1,608.23,1386.24Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#33308e",
    d: "M468 1427.66c-31 30.56-40.58 86.71-42.58 102.65a72.49 72.49 0 00-6.37 20.74c-3.68 25.19-2.6 51.78-2 77.16.2 8.35.57 16.7 1 25l4.31-.8c-.27-5.26-.53-10.53-.7-15.79-.78-22.73-.76-45.52.29-68.24.54-11.74 1.63-23.54 6.18-34.43a4.86 4.86 0 001.38-1.28c19.27-26.79 38.52-54.83 60.85-79.13 18.95-20.61 44-30.18 69.57-39.66 11.58-4.29 48-11.92 48.26-27.68C559.65 1391.9 503.64 1392.48 468 1427.66zM466.66 1412.66a101.2 101.2 0 01-.66-35.18c-1.18.66-2.32 1.31-3.44 2a103.67 103.67 0 001 33.92C463.93 1415.4 467 1414.66 466.66 1412.66zM454.82 1419a132.74 132.74 0 01-4.53-31.35c-1.05.76-2.08 1.57-3.1 2.39a135.55 135.55 0 004.49 29.69C452.21 1421.65 455.34 1421 454.82 1419z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbd3eb",
    d: "M506.62,1629.5a113.37,113.37,0,0,1-47,92.09H326.21A113.68,113.68,0,0,1,282,1604.71a110.66,110.66,0,0,1,6.25-19.61H497.61a110.74,110.74,0,0,1,6.28,19.61A113,113,0,0,1,506.62,1629.5Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#c0c9e7",
    d: "M506.62,1629.5a113.37,113.37,0,0,1-47,92.09H326.21c174.28,8.65,171.4-136.49,171.4-136.49a110.74,110.74,0,0,1,6.28,19.61A113,113,0,0,1,506.62,1629.5Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M590.18,1085l3.88-2.12,48,25.34,34.52-20.29,26.05,56,67-33.64,20,26.68,28.06-56.38,25.72,68.53,25.86-14.09.28.07a142.74,142.74,0,0,1-147,103.16c-78.56-5.44-137.83-73.8-132.45-152.37Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#6669b0",
    d: "M590.18,1085l3.88-2.12,48,25.34,34.52-20.29,26.05,56,67-33.64,20,26.68,28.06-56.38,25.72,68.53,25.86-14.09.28.07a142.74,142.74,0,0,1-147,103.16c-78.56-5.44-137.83-73.8-132.45-152.37Z",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorimg);
export default __webpack_public_path__ + "static/media/errorimg.85b329b7d45f299a4d442277e670eb37.svg";
export { ForwardRef as ReactComponent };